module.exports = __webpack_public_path__ + "img/favicon.f9c3c19a.ico";